import { getLocalStorage, setLocalStorage } from 'src/utils/storage'

const signInMethods = [
  'email',
  'google',
  'discord',
  'twitter',
  'apple',
] as const
export type SignInMethod = (typeof signInMethods)[number]

const VALID_METHODS: ReadonlySet<SignInMethod> = new Set(signInMethods)

const LAST_ATTEMPTED_KEY = 'auth::last-attempted-signin-method'
const LAST_SUCCESSFUL_KEY = 'auth::last-successful-signin-method'

function readMethod(key: string): SignInMethod | undefined {
  const v = getLocalStorage(key)
  return v && VALID_METHODS.has(v as SignInMethod)
    ? (v as SignInMethod)
    : undefined
}

function writeMethod(key: string, method: string) {
  if (!VALID_METHODS.has(method as SignInMethod)) return
  setLocalStorage(key, method)
}

export function getLastAttemptedSignInMethod(): SignInMethod | undefined {
  return readMethod(LAST_ATTEMPTED_KEY)
}

export function setLastAttemptedSignInMethod(method: string) {
  writeMethod(LAST_ATTEMPTED_KEY, method)
}

export function getLastSuccessfulSignInMethod(): SignInMethod | undefined {
  return readMethod(LAST_SUCCESSFUL_KEY)
}

export function setLastSuccessfulSignInMethod(method: string) {
  writeMethod(LAST_SUCCESSFUL_KEY, method)
}
